e4.product = {
    debug: false,
    init: function () {
        if ( jQuery( '.js-e-product-form, .js-e-productlist, .js-juuls-navigation-spot-product, .js-relewise-search' ).length > 0 ) {
            e4.require.js( e4.settings.require.jQueryValidate, function () {
                e4.product.bindEvents();
                e4.product.variants.init();
            } );
        }
        if(jQuery('.js-juuls-pdf-price-modal').length === 1){
            e4.require.js( e4.settings.require.summerNote);
        }
    },
    bindEvents: function () {
        jQuery( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
            e4.product.validateForm( domForm );
        } )
        jQuery( document ).on( 'input', '.js-juuls-cart-quantity', function ( event ) {
            e4.product.collieRound( event );
        } ).on( 'click', '.js-juuls-cart-quantity', function ( event ) {
            if(parseInt(event.target.value) === 1 && parseInt(event.target.max) === 1){
                e4.product.collieInfoMsg( event );
            }
        } );
        jQuery( '.js-e-productlist' ).on( 'builded.e4.productlist inserted.e4.productlist loaded.e4.jsonpublisher', function ( event ) {
            jQuery( event.target ).find( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
                e4.product.validateForm( domForm );
            } );
        } );
        jQuery( '.js-e-product-images, #js-e-product-image-modal' ).on( 'loaded.e4.jsonpublisher', '.js-e-jsonpublisher', function ( event ) {
            jQuery( event.target ).on( 'mouseenter', '.carousel-indicators li', function ( event ) {
                jQuery( event.target ).trigger( 'click' );
            } );
        } );
        jQuery( '.js-e-product-images' ).find( '.js-e-jsonpublisher' ).on( 'load.e4.jsonpublisher', function ( event ) {
            jQuery( event.target ).addClass( 'is-loading' );
        } ).on( 'loaded.e4.jsonpublisher', function ( event ) {
            jQuery( event.target ).removeClass( 'is-loading' );
        } );
    },
    validateForm: function ( domForm ) {
        var jForm = jQuery( domForm );
        if ( e4.cart && e4.cart._jsonData ) {
            e4.cart.disableAddToCartButtonIfLowOnStock( e4.cart._jsonData );
        }
        jForm.validate( {
            submitHandler: function ( domForm ) {
                if ( jForm.is( '.js-e-product-form-removefromcart' ) === true ) {
                    e4.product.removeFromCart( domForm );
                }
                else /* if ( jForm.is( '.js-e-product-form-addtocart' ) === true )*/ {
                    e4.product.addToCart( domForm );
                }
            }
        } );
    },
    addToCart: function ( domForm ) {
        var jForm       = jQuery( domForm ),
            arrFormData = jForm.serializeArray(),
            objFormData = {};
        objFormData.fromForm = domForm;
        for ( var i = 0; i < arrFormData.length; i++ ) {
            objFormData[ arrFormData[ i ].name ] = arrFormData[ i ].value;
        }
        jQuery.extend( objFormData, {
            Redirect: false
        } );
        if ( jForm.is( '.js-e-product-form-download' ) === true ) {
            e4.download.cart.addProduct( objFormData );
        }
        else {
            e4.cart.addProduct( objFormData );
        }
    },
    removeFromCart: function ( domForm ) {
        var jForm       = jQuery( domForm ),
            arrFormData = jForm.serializeArray(),
            objFormData = {};
        for ( var i = 0; i < arrFormData.length; i++ ) {
            objFormData[ arrFormData[ i ].name ] = arrFormData[ i ].value;
        }
        jQuery.extend( objFormData, {
            Redirect: false
        } );
        if ( jForm.is( '.js-e-product-form-download' ) === true ) {
            e4.download.cart.removeProduct( objFormData );
        }
        else {
            e4.cart.removeProduct( objFormData );
        }
    },
    collieInfoMsg: function ( event ) {
        var eventTarget = event.target,
            jEventTarget;
        if ( eventTarget === undefined ) {
            jEventTarget = event;
        }
        else {
            jEventTarget = jQuery( eventTarget )
        }
        e4.product.popover.show( jEventTarget );
    },
    collieRound: function ( event ) {
        var jInput           = jQuery( event.target ),
            intQuantityStock = jInput.data( 'stockminuswhatsincart' ),
            intOutputValue   = jInput.val();
        if ( isNaN( intOutputValue ) ) {
            intOutputValue = 1;
        }
        
        if(parseInt( intOutputValue ) === 1 && parseInt( intQuantityStock ) === 1){
            jInput.val( parseInt( intQuantityStock ) );
            e4.product.collieInfoMsg( event );
        }else if ( parseInt( intOutputValue ) > 1 && ( parseInt( intQuantityStock ) <= parseInt( intOutputValue ) ) ) {
            jInput.val( parseInt( intQuantityStock ) );
            e4.product.collieInfoMsg( event );
        }
        else {
            e4.product.popover.dispose( event.target );
        }
    },
    popover: {
        timeoutDuration: 4000,
        timeout: null,
        show: function ( domPopoverTarget ) {
            jQuery( '.has-popover-shown' ).each( function ( intIndex, domElement ) {
                if ( domPopoverTarget !== domElement ) {
                    jQuery( domElement ).popover( 'hide' );
                }
            } );
            e4.product.popover.timer.clear();
            e4.product.popover.timer.set( domPopoverTarget );
            jQuery( domPopoverTarget ).popover( 'show' );
        },
        hide: function ( domPopoverTarget ) {
            e4.product.popover.timer.clear();
            jQuery( domPopoverTarget ).popover( 'hide' );
        },
        dispose: function(domPopoverTarget){
            e4.product.popover.timer.clear();
            jQuery( domPopoverTarget ).popover('dispose');
        },
        timer: {
            set: function ( domPopoverTarget ) {
                e4.product.popover.timer.clear();
                e4.product.popover.timeout = setTimeout( function () {
                    e4.product.popover.hide( domPopoverTarget );
                }, e4.product.popover.timeoutDuration );
            },
            clear: function () {
                if ( e4.product.popover.timeout ) {
                    e4.product.popover.timeout = clearTimeout( e4.product.popover.timeout );
                }
            }
        }
    }
};
